import React from 'react'
import styled from 'styled-components'
import Pagination from 'core/pages/Pagination'
import { Sidebar } from 'core/components/sidebar'
import { mq, spacing, screenReadersOnlyMixin } from 'core/theme'
import colors from 'core/theme/colors'
import classNames from 'classnames'
import Hamburger from 'core/components/Hamburger'
import { useI18n } from '@devographics/react-i18n'
import Header from './Header'
import Footer from './Footer'
// import SurveyBanner from 'core/components/SurveyBanner'

const MainLayout = ({
    context,
    showPagination,
    showSidebar,
    toggleSidebar,
    closeSidebar,
    children
}: {
    context: any
    showPagination?: boolean
    showSidebar?: boolean
    toggleSidebar?: () => void
    closeSidebar: () => void
    children?: React.ReactNode
}) => {
    const { getString } = useI18n()
    return (
        <>
            <Skip href="#page-main">{getString('general.skip_to_content')?.t}</Skip>
            {/* <SurveyBanner /> */}
            <Header showPagination={showPagination}>
                <header>
                    <MenuToggle
                        onClick={toggleSidebar}
                        aria-haspopup="menu"
                        aria-expanded={showSidebar}
                    >
                        <ScreenReadersHint>{getString('general.open_nav')?.t}</ScreenReadersHint>
                        <Hamburger />
                    </MenuToggle>
                    <Sidebar showSidebar={showSidebar} closeSidebar={closeSidebar} />
                </header>
            </Header>
            <Page showSidebar={showSidebar}>
                <DesktopHeader>
                    <Sidebar showSidebar={showSidebar} closeSidebar={closeSidebar} />
                </DesktopHeader>
                <PageContent className="PageContent">
                    <PageMain id="page-main">
                        {/* <PageMetaDebug /> */}
                        {children}
                    </PageMain>
                </PageContent>
            </Page>
            <Footer />
        </>
    )
}

const ScreenReadersHint = styled.span`
    ${screenReadersOnlyMixin}
`

const DesktopHeader = styled.header`
    @media ${mq.large} {
        border-right: 1px solid;
    }
    @media ${mq.smallMedium} {
        display: none;
    }
`
const Skip = styled.a`
    display: block;
    padding: 1rem 1rem;

    position: absolute;
    top: -900px;
    left: -900px;

    &:focus {
        display: inline-block;
        position: static !important;
        top: 0 !important;
        left: 0 !important;
        border: 2px solid white;
    }
`

const PaginationWrapper = styled.div`
    @media ${mq.smallMedium} {
        padding-left: 5rem;
        border-bottom: ${({ theme }) => theme.separationBorder};
    }
`

const MenuToggle = styled.button`
    display: block;
    background-color: transparent;
    outline: none;
    border: none;

    // position: absolute;
    // top: 0;
    // left: 0;

    cursor: pointer;

    padding: 0.825rem 1rem 0.5rem 1rem;

    width: 5rem;
    height: 3.71rem;

    box-sizing: border-box;

    svg {
        width: 2rem;
        height: auto;
    }

    @media ${mq.large} {
        display: none;
    }

    &:focus {
        border: 2px solid ${colors.greenLight};
        outline: 5px auto -webkit-focus-ring-color;
    }

    &:hover,
    &:focus {
        background: ${({ theme }) => theme.colors.backgroundAlt};
    }
`

const PageContent = styled.div`
    display: flex;
    flex-direction: column;
`

const Page = styled.div`
    @media ${mq.large} {
        display: grid;
        grid-template-columns: 350px calc(100% - 350px);
    }

    @media ${mq.smallMedium} {
        grid-template-columns: 5rem auto;
    }

    min-height: 100vh;
    position: relative;
`

const PageMain = styled.div`
    flex-grow: 1;
    /* overflow-x: hidden; */
    overflow-y: visible;
    max-width: 972px;
    margin 0 auto;
    width: 100%;

    @media ${mq.smallMedium} {
        padding: 56px ${spacing()};
    }

    @media ${mq.large} {
        padding: 72px 16px;
    }
`

export default MainLayout
